import { useTenantList } from '@/hooks/useSwr';
import { TenantSchema } from '@/types/schema';
import { LATEST_TENANT_STORAGE_KEY } from '@/utils/constants';

export const useFallbackTenant = ({
  skipCreate = true,
  refreshInterval = () => 0,
}: {
  skipCreate?: boolean;
  refreshInterval?: (data: TenantSchema[] | undefined) => number;
}) => {
  const latestTenantId = window.localStorage.getItem(LATEST_TENANT_STORAGE_KEY);
  const tenantList = useTenantList({
    skipCreate,
    refreshInterval,
  });

  const fallbackTenant =
    (tenantList
      ? tenantList.data?.find((tenant) => tenant.id === latestTenantId)
      : null) ??
    tenantList.data?.find((tenant) => tenant.is_personal) ??
    tenantList.data?.at(0);

  return {
    tenant: fallbackTenant,
    isLoading: tenantList.isLoading,
    error: tenantList.error,
  };
};
